import axios from 'axios'
// axios.defaults.baseURL = '/app'
axios.defaults.baseURL = process.env.BASE_API
let host = '//www.ccspin.com';
let wsHost = 'wss://www.ccspin.com/socket';

// let host = 'http://zdfzc.59156.cn';
// let wsHost = 'ws://zdfzc.59156.cn:5678';

// let host = 'https://zdcs.59156.cn';
// let wsHost = 'wss://zdcs.59156.cn:5678';
// let wsHost = 'wss://zdcs.59156.cn/socket';

export const hostUrl = host;
export const wsHostUrl = wsHost;

axios.interceptors.request.use(
  config => {
    var token = $cookies.get('token')
    var lang = $cookies.get('lang')
    config.params = {
      'is_pc': 1,
      'token': token,
      'lang': lang == 'en' ? 'en-us' : 'zh-cn'
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
)

//语言切换
export const getLang = params => {
  return axios.post(`${host}/api/User/switch_lang`, params)
}


// 获取首页信息
export const getindex = params => {
  return axios.post(`${host}/api/index/index`, params)
}

//分类信息
export const getClassify = params => {
  return axios.post(`${host}/api/category/first`, params)
}

//二级分类信息
export const getSecond = params => {
  return axios.post(`${host}/api/category/second`, params)
}

//商品详情
export const getDetail = params => {
  return axios.post(`${host}/api/Article/show`, params)
}

//收藏
export const getCollect = params => {
  return axios.post(`${host}/api/Article/collect`, params)
}

//评论点赞
export const getPraise = params => {
  return axios.post(`${host}/api/ArticleComment/praise`, params)
}

//删除评论
export const getCommentDel = params => {
  return axios.post(`${host}/api/ArticleComment/delete`, params)
}

//发布评论
export const getCommentSave = params => {
  return axios.post(`${host}/api/ArticleComment/save`, params)
}

//二级评论列表
export const getCommentSecond = params => {
  return axios.post(`${host}/api/ArticleComment/secondList`, params)
}

//发送验证码
export const getSendCode = params => {
  return axios.post(`${host}/api/Common/sendSms`, params)
}

//验证码登录
export const getCodeLogin = params => {
  return axios.post(`${host}/api/User/mobileLogin`, params)
}

//密码登录
export const getLogin = params => {
  return axios.post(`${host}/api/User/login`, params)
}

//协议
export const getAgreement = params => {
  return axios.post(`${host}/api/Common/agreement`, params)
}

//绑定手机号
export const getBind = params => {
  return axios.post(`${host}/api/User/bindMobile`, params)
}

//验证码验证
export const getCheckCode = params => {
  return axios.post(`${host}/api/Common/checkCode`, params)
}

//重置密码
export const getResetPwd = params => {
  return axios.post(`${host}/api/User/resetPassword`, params)
}

//搜索
export const getSearch = params => {
  return axios.post(`${host}/api/Article/search`, params)
}

//发布页面
export const getCreate = params => {
  return axios.post(`${host}/api/article/create`, params)
}

//发布信息
export const getSendSave = params => {
  return axios.post(`${host}/api/article/save`, params)
}

//上传
export const getUpload = params => {
  return axios.post(`${host}/api/Common/upload`, params)
}

//认证
export const getLegalize = params => {
  return axios.post(`${host}/api/Legalize/save`, params)
}

//认证详情
export const getLegalizeShow = params => {
  return axios.post(`${host}/api/Legalize/show`, params)
}

//更换联系人
export const getLegalizeUp = params => {
  return axios.post(`${host}/api/Legalize/update`, params)
}

//我的
export const getMember = params => {
  return axios.post(`${host}/api/User/center`, params)
}

//我的金币
export const getMemberCoin = params => {
  return axios.post(`${host}/api/User/moneyShow`, params)
}

//我的积分
export const getMemberScore = params => {
  return axios.post(`${host}/api/User/scoreShow`, params)
}

//收藏关注
export const getMemberCollect = params => {
  return axios.post(`${host}/api/User/collectToFollow`, params)
}

//礼品商城
export const getShop = params => {
  return axios.post(`${host}/api/Product/home`, params)
}

//礼品商城详情
export const getShopDetail = params => {
  return axios.post(`${host}/api/Product/show`, params)
}

//兑换列表
export const getChange = params => {
  return axios.post(`${host}/api/Product/orderList`, params)
}

//商户主页
export const getBusiness = params => {
  return axios.post(`${host}/api/UserComprofile/home`, params)
}

//删除发布
export const getBusinessDel = params => {
  return axios.post(`${host}/api/Article/delete`, params)
}

//商户修改
export const getBusinessEdit = params => {
  return axios.post(`${host}/api/UserComprofile/update`, params)
}

//商户资料
export const getBusinessInfo = params => {
  return axios.post(`${host}/api/UserComprofile/show`, params)
}

//商户详情
export const getBusinessDetail = params => {
  return axios.post(`${host}/api/UserComprofile/detail`, params)
}

//资讯
export const getMsgList = params => {
  return axios.post(`${host}/api/Article/getList`, params)
}

//关注商户
export const getFollow = params => {
  return axios.post(`${host}/api/User/follow`, params)
}

//评价
export const getCommentList = params => {
  return axios.post(`${host}/api/Ordercomment/getList`, params)
}

export const getTargetList = params => {
  return axios.post(`${host}/api/Ordercomment/targetList`, params)
}

//我的资料修改
export const getProfileEdit = params => {
  return axios.post(`${host}/api/User/profileEdit`, params)
}

//我的资料
export const getProfile = params => {
  return axios.post(`${host}/api/User/profile`, params)
}

//省市区
export const getArea = params => {
  return axios.post(`${host}/api/Common/area`, params)
}

//省市区 获取二级
export const getAreaTwo = params => {
  return axios.post(`${host}/api/Common/areaList`, params)
}

//意见反馈
export const getFeedback = params => {
  return axios.post(`${host}/api/Feedback/create`, params)
}

export const getFeedbackSave = params => {
  return axios.post(`${host}/api/Feedback/save`, params)
}

//礼品下单商品信息
export const getOrederMsg = params => {
  return axios.post(`${host}/api/Product/orderShow`, params)
}

// 获取活动列表
export const getActiveList = params => {
  return axios.post(`${host}/api/Activity/getList`, params)
}

// 获取活动详情
export const getActiveDetail = params => {
  return axios.post(`${host}/api/Activity/show`, params)
}

//抽奖
export const getActiveBtn = params => {
  return axios.post(`${host}/api/Activity/saveLottery`, params)
}

//我的奖品
export const getActivePrize = params => {
  return axios.post(`${host}/api/Activity/winningList`, params)
}

//投票
export const getActivevote = params => {
  return axios.post(`${host}/api/Activity/vote`, params)
}

//重置密码
export const getOldPwd = params => {
  return axios.post(`${host}/api/User/oldResetPassword`, params)
}

//发布跑腿类型
export const getOrderType = params => {
  return axios.post(`${host}/api/Order/create`, params)
}

//发布跑腿
export const getOrderSave = params => {
  return axios.post(`${host}/api/Order/save`, params)
}

//我的需求
export const getOrderList = params => {
  return axios.post(`${host}/api/Order/t1List`, params)
}

//我的需求详情
export const getOrderDetail = params => {
  return axios.post(`${host}/api/Order/t1Show`, params)
}

//报价列表
export const getOfferList = params => {
  return axios.post(`${host}/api/Order/offerList`, params)
}

//报价支付
export const getPayOffer = params => {
  return axios.post(`${host}/api/Order/payOffer`, params)
}

//完成订单
export const getReceive = params => {
  return axios.post(`${host}/api/Order/receive`, params)
}

//提交评价
export const getOrdercomment = params => {
  return axios.post(`${host}/api/Ordercomment/save`, params)
}

//删除评价
export const getOrdercommentDel = params => {
  return axios.post(`${host}/api/Ordercomment/delete`, params)
}

//默认地址
export const getAddressDefault = params => {
  return axios.post(`${host}/api/Address/default`, params)
}

//新增地址
export const getAddressEdit = params => {
  return axios.post(`${host}/api/Address/save`, params)
}

//地址列表
export const getAddressList = params => {
  return axios.post(`${host}/api/Address/getList`, params)
}

//编辑地址
export const getAddressShow = params => {
  return axios.post(`${host}/api/Address/show`, params)
}

//删除地址
export const getAddressDel = params => {
  return axios.post(`${host}/api/Address/delete`, params)
}

//签到
export const getSign = params => {
  return axios.post(`${host}/api/Sign/home`, params)
}

//签到提交
export const getSignSave = params => {
  return axios.post(`${host}/api/Sign/save`, params)
}

//回复评价
export const getOrderReply = params => {
  return axios.post(`${host}/api/Ordercomment/reply`, params)
}

//提交订单
export const getSaveOrder = params => {
  return axios.post(`${host}/api/Product/saveOrder`, params)
}

//兑换记录
export const getRecordList = params => {
  return axios.post(`${host}/api/Product/orderList`, params)
}

//兑换记录详情
export const getRecordDetail = params => {
  return axios.post(`${host}/api/Product/orderDetail`, params)
}

//我的消息
export const getMessageList = params => {
  return axios.post(`${host}/api/Common/MessageList`, params)
}

//我的消息详情
export const getMessageShow = params => {
  return axios.post(`${host}/api/Common/messageShow`, params)
}

//物流信息
export const getlogistics = params => {
  return axios.post(`${host}/api/Product/logistics`, params)
}

//商户认证信息
export const getLegalizemsg = params => {
  return axios.post(`${host}/api/UserComprofile/legalize`, params)
}

//跑腿员主页
export const getShowHome = params => {
  return axios.post(`${host}/api/User/showt2Home`, params)
}

//城市列表
export const getCityList = params => {
  return axios.post(`${host}/api/Common/areaList`, params)
}

//微信登录
export const getWxPcLogin = params => {
  return axios.post(`${host}/api/user/wxPcLogin`, params)
}
//微信登录
export const wxPcLoginCallback = params => {
  return axios.post(`${host}/api/user/wxPcLoginCallback`, params)
}
//微信登录
export const wxLogin = params => {
  return axios.post(`${host}/api/user/wxLogin`, params)
}

//帮助中心
export const getHelp = params => {
  return axios.post(`${host}/api/Help/getList`, params)
}

//帮助中心详情
export const getHelpShow = params => {
  return axios.post(`${host}/api/Help/show`, params)
}

//分享
// export const getShare= params => {
//   return axios.post(`${host}/api/Common/shareCallback`, params)
// }
export const getShare = params => {
  return axios.post(`${host}/api/common/getCode`, params)
}

//微信登录
export const getWxcallback = params => {
  return axios.post(`${host}/api/User/wxPcLoginCallback`, params)
}

//下载二维码
export const getAppDownload = params => {
  return axios.post(`${host}/api/Common/appDownload`, params)
}

//微信解绑
export const getdisWx = params => {
  return axios.post(`${host}/api/user/disMiss`, params)
}


// 2022 - 12 -26 新增接口   https://www.showdoc.com.cn/2156623704503301/9695254500313373

//首页推送公告消息
export const getNoticeMessage = params => {
  return axios.post(`${host}/api/push_message/getNoticeList`, params)
}

//首页推送消息
export const getPushMessage = params => {
  return axios.post(`${host}/api/push_message/getList`, params)
}

//首页推送消息
export const getPushMessageDetail = params => {
  return axios.post(`${host}/api/push_message/detail`, params)
}

//首页推送消息 - 不在提示
export const notPromptAgain = params => {
  return axios.post(`${host}/api/push_message/prompt_again`, params)
}

//socket绑定uid
export const addUserSocket = params => {
  return axios.post(`${host}/api/common/add_user_socket`, params)
}

//消息列表
export const conversationList = params => {
  return axios.post(`${host}/api/user_conversation/conversation_list`, params)
}

//消息详情
export const conversationDetail = params => {
  return axios.post(`${host}/api/user_conversation/conversation_detail`, params)
}

//消息详情
export const sendConversation = params => {
  return axios.post(`${host}/api/user_conversation/send`, params)
}

//创建会话
export const createConversation = params => {
  return axios.post(`${host}/api/user_conversation/create_send`, params)
}

//删除会话
export const delConversation = params => {
  return axios.post(`${host}/api/user_conversation/del_conversation`, params)
}


//我发布的或商家发布的帖子
export const getSelfList = params => {
  return axios.post(`${host}/api/Article/getSelfList`, params)
}




//获取发布跑腿类型
export const getOrderKinds = params => {
  return axios.post(`${host}/api/order/OrderBelonging`, params)
}
//获取订单重量收费
export const getOrderWeight = params => {
  return axios.post(`${host}/api/order/OrderWeight`, params)
}
//获取跑腿员等级
export const getOrderUserGrade = params => {
  return axios.post(`${host}/api/order/UserGrade`, params)
}

//提交商务合作
export const submitCooperation = params => {
  return axios.post(`${host}/api/user/cooperation`, params)
}


//冻结详情
export const getFrozenDetail = params => {
  return axios.post(`${host}/api/user/frozen_detail`, params)
}
//申请解冻
export const applyThawFrozen = params => {
  return axios.post(`${host}/api/user/thaw`, params)
}
//补充资料
export const addInformation = params => {
  return axios.post(`${host}/api/user/supplement`, params)
}






// 2022 - 12 -26 新增接口 end

// 2024-06-16 新增接口

// 商城商品提交订单
export const placeOrder = params => {
  return axios.post(`${host}/api/product/placeOrder`, params)
}

// 支付订单
export const payment = params => {
  return axios.post(`${host}/api/order/payment`, params)
}

// 充值套餐
export const rechargePackage = params => {
  return axios.post(`${host}/api/order/rechargePackage`, params)
}
// 充值金币套餐提交订单
export const goldPlaceOrder = params => {
  return axios.post(`${host}/api/order/placeOrder`, params)
}
// 获取订单支付状态
export const orderStatus = params => {
  return axios.post(`${host}/api/order/orderStatus`, params)
}
// 获取七牛云上传地址和token
export const siteConfig = params => {
  return axios.post(`${host}/api/index/siteConfig`, params)
}
// 商城认证购买提示信息
export const authenticationComprofileConfig = params => {
  return axios.post(`${host}/api/user/authenticationComprofileConfig`, params)
}
// 支付认证费用
export const authenticationComprofile = params => {
  return axios.post(`${host}/api/user/authenticationComprofile`, params)
}
// 查看商家时的购买信息
export const merchantPurchaseConfig = params => {
  return axios.post(`${host}/api/user/merchantPurchaseConfig`, params)
}
// 支付查看商家时费用
export const openMerchantPurchase = params => {
  return axios.post(`${host}/api/user/openMerchantPurchase`, params)
}
// 编辑认证信息
export const ComprofileEditPermissionsConfig = params => {
  return axios.post(`${host}/api/user/ComprofileEditPermissionsConfig`, params)
}
// 支付编辑费用
export const ComprofileEditPermissions = params => {
  return axios.post(`${host}/api/user/ComprofileEditPermissions`, params)
}



// WEBPACK FOOTER //
// ./src/api/api.js